import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

export default function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-logo-section">
          <p className="logo">RISHABH.AI</p>
          <div className="footer-status">
            <span className="status-dot"></span>
            <span>Available for select AI / Founding roles</span>
          </div>
        </div>
        
        <div className="footer-right">
          <ul className="footer-links">
            <Link to="/"><li>Home</li></Link> 
            <Link to="/projects"><li>Projects</li></Link> 
            <Link to="/about"><li>About</li></Link> 
            <Link to="/contact"><li>Contact</li></Link> 
          </ul>

          <div className="social-links">
            <a href="https://github.com/rishabh-108272" target="_blank" rel="noopener noreferrer" className="social-icon">GitHub</a>
            <a href="https://www.linkedin.com/in/rishabh-verma-875214247/" target="_blank" rel="noopener noreferrer" className="social-icon">LinkedIn</a>
            <a href="mailto:rishabhverma3648@gmail.com" className="social-icon">Email</a>
          </div>

          <p className="copyright">&copy; {new Date().getFullYear()} Rishabh Verma. Crafted with focus.</p>
        </div>
      </div>
    </footer>
  );
}